import React from 'react';
import PropTypes from "prop-types";
import ReactPlayerLoader from '@brightcove/react-player-loader';

import './styles/main'

export default class BrightcovePlayer extends React.Component {
  render() {
    let { videoID, accountID, playerID, attrs, options, onSuccess } = this.props;

    return (
      <ReactPlayerLoader
        attrs={attrs}
        options={options}
        videoId={videoID}
        accountId={accountID}
        playerId={playerID}
        onSuccess={onSuccess}
      />
    )
  }
}

BrightcovePlayer.propTypes = {
  videoID:   PropTypes.string.isRequired,
  accountID: PropTypes.string.isRequired,
  playerID:  PropTypes.string,
  attrs:     PropTypes.object,
  onSuccess: PropTypes.func
};

BrightcovePlayer.defaultProps = {
  playerID: "default",
  attrs:    {},
  options:  {},
  onSuccess: () => {}
};
